import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllStatus,
  removeStatus,
  restoreStatus
} from '../../redux/actions/status';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const status = useSelector(state => state.status);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = status.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeStatus(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreStatus({ _id: id, active: true }));
  };

  useEffect(() => {
    dispatch(getAllStatus());
  }, [dispatch]);

  const columns = [
    {
      title: 'Ícone',
      data: 'icon',
      orderable: false,
      className: 'no-export',
      render: data => `<i class="${data}"/>`
    },
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Departamento',
      data: 'department.name',
      render: data => data || '---'
    },
    {
      title: 'Pausa Produtiva',
      data: 'isProductive',
      className: 'no-export',
      render: data =>
        data.toString() === 'false'
          ? '<i class="fa fa-times text-danger">&nbsp;</i>'
          : '<i class="fa fa-check text-success">&nbsp;&nbsp;</i>'
    },
    {
      title: 'Descrição',
      data: 'description',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      className: 'no-export',
      orderable: false,
      render: (data, type, obj) => {
        return `<div class="btn-group">
        ${
          !(currentPermissions.options.l && currentPermissions.options.u)
            ? ''
            : `<button id="${data}" type="button" title="Editar" ${(data ===
                '5972571dbe9d01feb20f45b6' ||
                data === '5972571dbe9d01feb20f45b7') &&
                'disabled=""'} class="btn btn-warning button-action button-action-update m-1 rounded"><i class="fa fa-edit"></i></button>`
        }
                  ${
                    !obj.active ||
                    !(
                      currentPermissions.options.l &&
                      currentPermissions.options.d
                    )
                      ? ''
                      : `<button id="${data}" type="button" title="Excluir" ${(data ===
                          '5972571dbe9d01feb20f45b6' ||
                          data === '5972571dbe9d01feb20f45b7') &&
                          'disabled=""'} class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
                  }
                  ${
                    obj.active ||
                    !(
                      currentPermissions.options.l &&
                      currentPermissions.options.r
                    )
                      ? ''
                      : `<button id="${data}" type="button" title="Restaurar" ${(data ===
                          '5972571dbe9d01feb20f45b6' ||
                          data === '5972571dbe9d01feb20f45b7') &&
                          'disabled=""'} class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
                  }
                </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/status/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o status'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o status'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'Status'}
        url={'/status/add'}
        updateList={() => dispatch(getAllStatus())}
        isFetching={status.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          order={[[1, 'asc']]}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
